// extracted by mini-css-extract-plugin
export default {"linebreak":"styles-module__linebreak--q4jDZ","hasMargin":"styles-module__hasMargin--mTihW"};